import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../config";
import axios from "axios";

const Register = () => {
  const [categories, setCategories] = useState([]);
  const [, setLoading] = useState(true);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    userId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    category: "",
    category_id: "",
    category_name: "",
    password: ""
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [emailexisterror, setEmailExistError] = useState("");

  const generateUserID = () => {
    return "USR" + Math.floor(10000 + Math.random() * 90000);
  };

  useEffect(() => {
    fetch(
      `${API_URL}/api-select-all-category.php`
    )
      .then((response) => response.json())
      .then((data) => {
        setCategories(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const id = generateUserID();
    setFormData((prev) => ({ ...prev, userId: id }));
  }, []);

  //if (loading) return;// <h2>Loading...</h2>;

  // ✅ UPDATED HANDLE CHANGE
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "category") {
      const selectedItem = categories.find(
        (item) => item.menu_url === value
      );

      setFormData({
        ...formData,
        category: value,
        category_id: selectedItem ? selectedItem.id : "",
        category_name: selectedItem ? selectedItem.menu_name : ""
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.firstName.trim())
      newErrors.firstName = "First name is required";
    if (!formData.lastName.trim())
      newErrors.lastName = "Last name is required";

    if (!formData.email)
      newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email format";

    if (!formData.category)
      newErrors.category = "Please select a category";

    if (!formData.password)
      newErrors.password = "Password is required";
    else if (formData.password.length < 6)
      newErrors.password = "Minimum 6 characters required";

    if (!formData.confirmPassword)
      newErrors.confirmPassword = "Confirm your password";
    else if (formData.password !== formData.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrors({});
    setMessage("");

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    //Check user Exist or not
    
    const checkEmailExists = async (email) => {
      const res = await fetch(`${API_URL}/api-select-all-users.php`);
      const users = await res.json();

      return users.some(user => user.email === email);
    };


    try {
      const emailExists = await checkEmailExists(formData.email);

      if (emailExists) {
        setEmailExistError("Email already exists");
        return;
      }
      const response = await fetch(
        `${API_URL}/api-user-registration.php`,
        {
          method: "POST",
          credentials: "include", // REQUIRED
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        });

      const data = await response.json();
      console.log(data);


      if (data.status === "success") {

  const loginResponse = await axios.post(
    `${API_URL}/api-select-user-login-api.php`,
    {
      email: formData.email,
      password: formData.password
    },
    { withCredentials: true }
  );

  if (loginResponse.data.status === "success") {
    navigate("/dashboard");
  }
}

else {
        setMessage(data.message || "Registration failed");
      }

      //setMessage("Registration successful!");

      setFormData({
        userId: generateUserID(),
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        category: "",
        category_id: "",
        category_name: "",
        password: ""
      });
    } catch (error) {
      console.error(error);
      setMessage("Something went wrong.");
    }
  };

  return (
    <div>
      <div className="breadcrumb">
        <Link to="/">Home</Link> : Sign Up
      </div>

      <div className="ibodywrap">
        <div className="reg-panel">
          <div className="reg-left-panel">
            <form className="logreg-box" onSubmit={handleSubmit}>
              <h2>New User Sign Up</h2>

              {message && <p className="success">{message}</p>}

              <div className="form-row">
                <div className="form-col03">
                  <input type="hidden" name="userId" value={formData.userId} readOnly className="lr-textbox" />

                  <input
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    type="text"
                    className="lr-textbox"
                    placeholder="First Name*"
                  />
                  <p className="error">{errors.firstName}</p>
                </div>

                <div className="form-col03">
                  <input
                    name="middleName"
                    value={formData.middleName}
                    onChange={handleChange}
                    type="text"
                    className="lr-textbox"
                    placeholder="Middle Name"
                  />
                </div>

                <div className="form-col03">
                  <input
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    type="text"
                    className="lr-textbox"
                    placeholder="Last Name*"
                  />
                  <p className="error">{errors.lastName}</p>
                </div>
              </div>

              <div className="form-row">
                <div className="form-col02">
                  <input name="email" value={formData.email} onChange={handleChange} type="text" className="lr-textbox" placeholder="Email ID*"/>
                  {emailexisterror && <div className="form-error-message">{emailexisterror}</div>}
                  <p className="error">{errors.email}</p>
                </div>

                <div className="form-col02">

                  <select name="category" value={formData.category} onChange={handleChange} className="lr-textbox">
                    <option value="">Select Category *</option>
                    {categories.map((item) => (
                      <option key={item.id} value={item.menu_url}>
                        {item.menu_name}
                      </option>
                    ))}
                  </select>

                  <p className="error">{errors.category}</p>

                  <input
                    type="hidden"
                    className="lr-textbox"
                    value={formData.category_id}
                    placeholder="Category ID"
                    readOnly
                  />

                  {/* ✅ NEW TEXTBOX 2: NAME */}
                  <input
                    type="hidden"
                    className="lr-textbox"
                    value={formData.category_name}
                    placeholder="Category Name"
                    readOnly
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-col02">
                  <input
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    type="password"
                    className="lr-textbox"
                    placeholder="Password*"
                  />
                  <p className="error">{errors.password}</p>
                </div>

                <div className="form-col02">
                  <input
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    type="password"
                    className="lr-textbox"
                    placeholder="Confirm Password*"
                  />
                  <p className="error">{errors.confirmPassword}</p>
                </div>
              </div>

              <div className="form-row1">
                <button type="submit" className="logreg-btn">
                  Sign Up
                </button>
              </div>

              <div className="form-row">
                Already have an Account? <Link to="/">Sign In</Link>
              </div>
            </form>
          </div>

          <div className="reg-right-panel">Right Panel</div>
        </div>
      </div>
    </div>
  );
};

export default Register;